import { CreateRawMaterialParams, IRawMaterialService } from './contracts';

import apiClient from '../../api/index';
import { createUrl } from '_clean-code/utils/urlHelper';

export const RawMaterialService: IRawMaterialService = {
  getAll: async (): Promise<any[]> => {
    const response = await apiClient.request(
      'GET',
      createUrl('/raw-materials').toStringUrl()
    );
    return response as any[];
  },

  async create(params: CreateRawMaterialParams): Promise<any> {
    const response = await apiClient.request(
      'POST',
      createUrl('/raw-materials').toStringUrl(),
      params
    );
    return response;
  },
  async update(params: CreateRawMaterialParams): Promise<any> {
    const response = await apiClient.request(
      'PUT',
      createUrl(`/raw-materials/${params.id}`).toStringUrl(),
      { companyId: params.companyId, name: params.name, id: params.id }
    );
    return response;
  },
  async delete(id: string): Promise<any> {
    const response = await apiClient.request(
      'DELETE',
      createUrl(`/raw-materials/${id}`).toStringUrl()
    );
    return response;
  }
};
